export const fallback: any = {
    "hcm.analytics.ABOVE": "Acima da faixa",
    "hcm.analytics.ADD_STAFF_REQUISITION": "Cadastrar",
    "hcm.analytics.ADOPTED": "Filho(a) Adotivo(a)",
    "hcm.analytics.AEROPORTO": "Aeroporto",
    "hcm.analytics.ALAMEDA": "Alameda",
    "hcm.analytics.ALL": "Todas",
    "hcm.analytics.APPROVED": "Aprovado",
    "hcm.analytics.APPROVED_FEMALE": "Aprovada",
    "hcm.analytics.APRENDIZ_CONTRATADO_NOS_TERMOS_DO_ART_428_DA_CLT_REGULAMENTADO_PELO_DECRETO_N_5598_DE_1_DE_DEZEMBRO_DE_2005": "Aprendiz contratado nos termos do art 428 da CLT regulamentado pelo decreto nº 5598 de 1 de dezembro de 2005",
    "hcm.analytics.AREA": "Área",
    "hcm.analytics.AVENIDA": "Avenida",
    "hcm.analytics.AWAITING_LEADER_REVIEW": "Aguardando aprovação",
    "hcm.analytics.AWAITING_REVIEW": "Aguardando avaliação",
    "hcm.analytics.Academic_profile": "Perfil acadêmico",
    "hcm.analytics.Access_analytics": "Acessar Analytics",
    "hcm.analytics.Access_profile": "Acessar perfil",
    "hcm.analytics.Achieved_in_date": "Adquirido em {{date}}",
    "hcm.analytics.Activities_performed": "Atividades desenvolvidas",
    "hcm.analytics.Add": "Adicionar",
    "hcm.analytics.Address": "Endereço",
    "hcm.analytics.Addresses": "Endereços",
    "hcm.analytics.Approval": "Aproveitamento",
    "hcm.analytics.Apr_Jun": "Abr-Jun",
    "hcm.analytics.Attendance_of_attendance": "Frequência de {{attendance}}",
    "hcm.analytics.Avaliacoes_pendentes": "Avaliações pendentes",
    "hcm.analytics.Average_average": "Média {{average}}",
    "hcm.analytics.BACHELOR_COMPLETE": "Educação Superior completa",
    "hcm.analytics.BACHELOR_INCOMPLETE": "Educação Superior incompleta",
    "hcm.analytics.BALNEARIO": "Balneário",
    "hcm.analytics.BANKS": "Bancos",
    "hcm.analytics.BELOW": "Abaixo da faixa",
    "hcm.analytics.BIRTH": "Nascimento",
    "hcm.analytics.BIRTH_DAY": "Data de nascimento",
    "hcm.analytics.BLACK": "Preta",
    "hcm.analytics.BLOCKED": "Bloqueada",
    "hcm.analytics.BLOCO": "Bloco",
    "hcm.analytics.BRANCH_OFFICE": "Filial",
    "hcm.analytics.BROWN": "Parda",
    "hcm.analytics.Birth_certificate": "Certidão de nascimento",
    "hcm.analytics.Book_no": "Nº do livro",
    "hcm.analytics.CAMPO": "Campo",
    "hcm.analytics.CANCELED": "Cancelado",
    "hcm.analytics.CANCELED_FEMALE": "Cancelada",
    "hcm.analytics.CEP": "CEP",
    "hcm.analytics.CHACARA": "Chácara",
    "hcm.analytics.CHEMICAL_AND_PETROCHEMICAL": "Química e petroquímica",
    "hcm.analytics.CHILD": "Filho(a)",
    "hcm.analytics.CLIENT": "Cliente",
    "hcm.analytics.CLOTHES_SHOES_AND_ACCESSORIES": "Roupas, calçados e acessórios",
    "hcm.analytics.CNAE": "CNAE",
    "hcm.analytics.CNH_desc": "Carteira Nacional de Habilitação",
    "hcm.analytics.CNPJ": "CNPJ",
    "hcm.analytics.COLONIA": "Colônia",
    "hcm.analytics.COMMERCIAL_AND_SHOPPING_MALLS": "Imóveis comerciais e shoppings",
    "hcm.analytics.COMPLETED": "Concluído",
    "hcm.analytics.CONCUBINE": "Cuncubino(a)",
    "hcm.analytics.CONDOMINIO": "Condomínio",
    "hcm.analytics.CONJUNTO": "Conjunto",
    "hcm.analytics.CONSENSUS": "Consenso",
    "hcm.analytics.CONSTRUCTION_AND_BROKERAGE": "Construção civil e intermediação",
    "hcm.analytics.CONTINUOUS": "Contínua",
    "hcm.analytics.CONTRACT_SITUATION_ACTIVE": "Ativo",
    "hcm.analytics.CONTRACT_SITUATION_CLOSED": "Encerrado",
    "hcm.analytics.CONTRACT_SITUATION_LEAVE": "Afastado",
    "hcm.analytics.CONTRATO_DE_TRABALHO_POR_PRAZO_DETERMINADO_REGIDO_PELA_LEI_N_9601_DE_21_DE_JANEIRO_DE_1998": "Contrato de trabalho por prazo determinado regido pela lei nº 9601 de 21 de janeiro de 1998",
    "hcm.analytics.CONTRATO_DE_TRABALHO_POR_PRAZO_DETERMINADO_REGIDO_POR_LEI_ESTADUAL": "Contrato de trabalho por prazo determinado regido por lei estadual",
    "hcm.analytics.CONTRATO_DE_TRABALHO_POR_PRAZO_DETERMINADO_REGIDO_POR_LEI_MUNICIPAL": "Contrato de trabalho por prazo determinado regido por lei municipal",
    "hcm.analytics.CONTRATO_DE_TRABALHO_POR_TEMPO_DETERMINADO_REGIDO_PELA_LEI_N_8745_DE_9_DE_DEZEMBRO_1993_COM_A_REDACAO_DADA_PELA_LEI_N_9849_DE_26_DE_OUTUBRO_DE_1999": "Contrato de trabalho por tempo determinado regido pela lei n 8745 de 9 de dezembro 1993 com a redação dada pela lei nº 9849 de 26 de outubro de 1999",
    "hcm.analytics.CONTRIB_INDIVIDUAL_AUTONOMO_CONTRATADO_POR_CONTRIB_INDIVIDUAL_POR_PESSOA_FISICA_EM_GERAL_OU_POR_MISSAO_DIPLOMATICA_E_REPARTICAO_CONSULAR_DE_CARREIRA_ESTRANGEIRAS": "Contrib. Individual - Autônomo contratado por Contrib. Individual, por pessoa física em geral, ou por missão diplomática e repartição consular de carreira estrangeiras",
    "hcm.analytics.CONTRIB_INDIVIDUAL_AUTONOMO_CONTRATADO_POR_EMPRESAS_EM_GERAL": "Contrib. Individual - Autônomo contratado por Empresas em geral",
    "hcm.analytics.CONTRIB_INDIVIDUAL_AUTONOMO_CONTRATADO_POR_ENTIDADE_BENEFICENTE_DE_ASSISTENCIA_SOCIAL_ISENTA_DA_COTA_PATRONAL": "Contrib. Individual - Autônomo contratado por Entidade Beneficente de Assistência Social isenta da cota patronal",
    "hcm.analytics.CONTRIB_INDIVIDUAL_COOPERADO_ELEITO_PARA_DIRECAO_DA_COOPERATIVA": "Contrib. Individual - Cooperado eleito para direção da Cooperativa",
    "hcm.analytics.CONTRIB_INDIVIDUAL_COOPERADO_FILIADO_A_COOPERATIVA_DE_PRODUCAO": "Contrib. Individual - Cooperado filiado a cooperativa de produção.",
    "hcm.analytics.CONTRIB_INDIVIDUAL_COOPERADO_QUE_PRESTA_SERVICOS_A_EMPRESA_POR_INTERMEDIO_DE_COOPERATIVA_DE_TRABALHO": "Contrib. Individual - Cooperado que presta serviços a empresa por intermédio de cooperativa de trabalho",
    "hcm.analytics.CONTRIB_INDIVIDUAL_COOPERADO_QUE_PRESTA_SERVICOS_A_ENTIDADE_BENEFICENTE_DE_ASSISTENCIA_SOCIAL_ISENTA_DA_COTA_PATRONAL_OU_PARA_PESSOA_FISICA": "Contrib. Individual - Cooperado que presta serviços a Entidade Beneficente de Assistência Social isenta da cota patronal ou para pessoa física",
    "hcm.analytics.CONTRIB_INDIVIDUAL_DIRETOR_NAO_EMPREGADO_COM_FGTS": "Contrib. Individual - Diretor não empregado com FGTS",
    "hcm.analytics.CONTRIB_INDIVIDUAL_DIRETOR_NAO_EMPREGADO_SEM_FGTS": "Contrib. Individual - Diretor não empregado sem FGTS",
    "hcm.analytics.CONTRIB_INDIVIDUAL_MICRO_EMPREENDEDOR_INDIVIDUAL_QUANDO_CONTRATADO_POR_PJ": "Contrib. Individual - Micro Empreendedor Individual, quando contratado por PJ",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_AUTONOMO_CONTRATADO_POR_CONTRIB_INDIVIDUAL_POR_PESSOA_FISICA_EM_GERAL_OU_POR_MISSAO_DIPLOMATICA_E_REPARTICAO_CONSULAR_DE_CARREIRA_ESTRANGEIRAS": "Contrib. Individual - Transportador autônomo contratado por Contrib. Individual, por pessoa física em geral, ou por missão diplomática e repartição consular de carreira estrangeiras",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_AUTONOMO_CONTRATADO_POR_EMPRESAS_EM_GERAL": "Contrib. Individual - Transportador autônomo contratado por Empresas em geral",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_AUTONOMO_CONTRATADO_POR_ENTIDADE_BENEFICENTE_DE_ASSISTENCIA_SOCIAL_ISENTA_DA_COTA_PATRONAL": "Contrib. Individual - Transportador autônomo contratado por Entidade Beneficente de Assistência Social isenta da cota patronal",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_COOPERADO_ELEITO_PARA_DIRECAO_DA_COOPERATIVA": "Contrib. Individual - Transportador Cooperado eleito para direção da Cooperativa.",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_COOPERADO_QUE_PRESTA_SERVICOS_A_EMPRESA_POR_INTERMEDIO_DE_COOPERATIVA_DE_TRABALHO": "Contrib. Individual - Transportador Cooperado que presta serviços a empresa por intermédio de cooperativa de trabalho",
    "hcm.analytics.CONTRIB_INDIVIDUAL_TRANSPORTADOR_COOPERADO_QUE_PRESTA_SERVICOS_A_ENTIDADE_BENEFICENTE_DE_ASSISTENCIA_SOCIAL_ISENTA_DA_COTA_PATRONAL_OU_PARA_PESSOA_FISICA": "Contrib. Individual - Transportador Cooperado que presta serviços a Entidade Beneficente de Assistência Social isenta da cota patronal ou para pessoa física",
    "hcm.analytics.CPF_desc": "Cadastro de Pessoa Física",
    "hcm.analytics.CTPS_desc": "Carteira de Trabalho e Previdência Social",
    "hcm.analytics.Category": "Categoria",
    "hcm.analytics.Certificate": "Certificado",
    "hcm.analytics.Certification": "Certificação",
    "hcm.analytics.Certification_number": "Certificação número",
    "hcm.analytics.Civil_certificate": "Certidão civil",
    "hcm.analytics.Commercial_emails": "Emails comerciais",
    "hcm.analytics.Company": "Empresa",
    "hcm.analytics.Competencias": "Competências",
    "hcm.analytics.Consult_job_description": "Consultar a descrição do cargo",
    "hcm.analytics.Contract_situation": "Situação do contrato",
    "hcm.analytics.Contracts": "Contratos",
    "hcm.analytics.Corporate_name": "Razão social",
    "hcm.analytics.Course": "Curso",
    "hcm.analytics.DAILY": "Diário",
    "hcm.analytics.DEATH": "Óbito",
    "hcm.analytics.DEFICIENCY": "Deficiência",
    "hcm.analytics.DIRETOR_SEM_VINCULO_EMPREGATICIO_PARA_O_QUAL_A_EMPRESA_OU_ENTIDADE_TENHA_OPTADO_POR_RECOLHIMENTO_AO_FGTS_OU_DIRIGENTE_SINDICAL": "Diretor sem vínculo empregatício para o qual a empresa ou entidade tenha optado por recolhimento ao FGTS ou dirigente sindical",
    "hcm.analytics.DIRIGENTE_SINDICAL_EM_RELACAO_A_REMUNERACAO_RECEBIDA_NO_SINDICATO": "Dirigente Sindical - Em relação a Remuneração Recebida no Sindicato.",
    "hcm.analytics.DISTRITO": "Distrito",
    "hcm.analytics.DOCTORAL": "Doutorado completo",
    "hcm.analytics.DOLAR": "Dólar",
    "hcm.analytics.DONE": "Concluída",
    "hcm.analytics.Department": "Departamento",
    "hcm.analytics.Details": "Detalhes",
    "hcm.analytics.Digit": "Dígito",
    "hcm.analytics.Digital_contacts": "Contatos eletrônicos",
    "hcm.analytics.EDIT": "Editar",
    "hcm.analytics.EDUCATION_SECTOR": "Setor de educação",
    "hcm.analytics.ELECTRICITY": "Energia elétrica",
    "hcm.analytics.ELEMENTARY_SCHOOL_COMPLETE": "5º ano completo do Ensino Fundamental",
    "hcm.analytics.ELEMENTARY_SCHOOL_INCOMPLETE": "5º ano incompleto do Ensino Fundamental",
    "hcm.analytics.EMANCIPATING": "Emancipação",
    "hcm.analytics.EMPREGADO_APRENDIZ": "Empregado - Aprendiz",
    "hcm.analytics.CONTRIBUINTE_INDIVIDUAL_AUTONOMO_EM_GERAL_EXCETO_SE_ENQUADRADO_EM_UMA_DAS_DEMAIS_CATEGORIAS_DE_CONTRIBUINTE_INDIVIDUAL": "Contribuinte Individual - Autônomo em geral, exceto se enquadrado em uma das demais categorias de contribuinte individual",
    "hcm.analytics.EMPREGADO_CONTRATO_POR_PRAZO_DETERMINADO_NOS_TERMOS_DA_LEI_6019_74": "Empregado - contrato por prazo determinado nos termos da Lei 6019/74",
    "hcm.analytics.EMPREGADO_CONTRATO_A_TERMO_FIRMADO_NOS_TERMOS_DA_LEI_9601_98": "Empregado - contrato a termo firmado nos termos da Lei 9601/98",
    "hcm.analytics.EMPREGADO_DOMESTICO": "Empregado - Doméstico",
    "hcm.analytics.EMPREGADO_GERAL": "Empregado - Geral",
    "hcm.analytics.EMPREGADO_TRABALHADOR_RURAL_POR_PEQUENO_PRAZO_DA_LEI_11_718_2008": "Empregado - Trabalhador Rural por Pequeno Prazo da Lei 11.718/2008",
    "hcm.analytics.EMPTY": "Vazia",
    "hcm.analytics.EQUIPMENT_MACHINERY_AND_PARTS": "Equipamentos, máquinas e peças",
    "hcm.analytics.ESPLANADA": "Esplanada",
    "hcm.analytics.ESTACAO": "Estação",
    "hcm.analytics.ESTAGIARIO": "Estagiário",
    "hcm.analytics.ESTRADA": "Estrada",
    "hcm.analytics.EX_PARTNER": "Ex-Parceiro(a)",
    "hcm.analytics.EX_SPOUSE": "Ex-Cônjuge",
    "hcm.analytics.Election_section": "Seção eleitoral",
    "hcm.analytics.Election_zone": "Zona eleitoral",
    "hcm.analytics.Emails": "E-mails",
    "hcm.analytics.Emergency_contacts": "Contatos de emergência",
    "hcm.analytics.Employer": "Empregador",
    "hcm.analytics.End_date_not_defined": "Data de conclusão não informada",
    "hcm.analytics.Enrollment": "Inscrição",
    "hcm.analytics.Expiry_date": "Data de validade",
    "hcm.analytics.FAILED": "Falha/Reprovação por nota(s)",
    "hcm.analytics.FARMING": "Agropecuária",
    "hcm.analytics.FAVELA": "Favela",
    "hcm.analytics.FAZENDA": "Fazenda",
    "hcm.analytics.FEIRA": "Feira",
    "hcm.analytics.FEMALE": "Feminino",
    "hcm.analytics.FINANCIAL_SERVICES": "Serviços financeiros",
    "hcm.analytics.FOOD_INDUSTRIES": "Indústrias de alimentos",
    "hcm.analytics.FOR": "Para",
    "hcm.analytics.FORTNIGHTLY": "Quinzenal",
    "hcm.analytics.FROM": "De",
    "hcm.analytics.Finished_on_value": "Concluído em {{value}}",
    "hcm.analytics.First_CNH_date": "Data da primeira CNH",
    "hcm.analytics.GALERIA": "Galeria",
    "hcm.analytics.GENDER": "Sexo",
    "hcm.analytics.GRANDCHILD": "Neto(a)",
    "hcm.analytics.GRANDPARENT": "Avô/Avó",
    "hcm.analytics.GRANJA": "Granja",
    "hcm.analytics.GREAT_GRANDCHILD": "Bisneto(a)",
    "hcm.analytics.GREAT_GRANDPARENT": "Bisavô/Bisavó",
    "hcm.analytics.GUARDIANSHIP": "Tutelado",
    "hcm.analytics.HEAD_OFFICE": "Matriz",
    "hcm.analytics.HEALTH_SECTOR": "Setor de saúde",
    "hcm.analytics.HEAVY_CONSTRUCTION_AND_ENGINEERING": "Construção pesada e engenharia",
    "hcm.analytics.HIGH": "Alto",
    "hcm.analytics.HIGH_SCHOOL_COMPLETE": "Ensino Médio completo",
    "hcm.analytics.HIGH_SCHOOL_INCOMPLETE": "Ensino Médio incompleto",
    "hcm.analytics.HOLDINGS": "Holdings",
    "hcm.analytics.HOTELS_AND_RESTAURANTS": "Hotelaria e Restaurantes",
    "hcm.analytics.HOUSEWARES": "Utilidades domésticas",
    "hcm.analytics.ILLITERATE": "Analfabeto, inclusive o que, embora tenha recebido instrução, não se alfabetizou",
    "hcm.analytics.IN": "Dentro da faixa",
    "hcm.analytics.INDEX": "Índice",
    "hcm.analytics.INDIAN": "Indígena",
    "hcm.analytics.INDUSTRIES_IN_GENERAL": "Indústrias em geral",
    "hcm.analytics.INFORMATION_TECHNOLOGY": "Tecnologia da informação",
    "hcm.analytics.INSURANCE_SECTOR": "Setor de seguros",
    "hcm.analytics.INTEGRATION_ERROR": "Erro na integração",
    "hcm.analytics.INTERDICTIONS": "Interdição",
    "hcm.analytics.IN_APPRAISAL": "Em avaliação",
    "hcm.analytics.IN_APPROVAL": "Em aprovação",
    "hcm.analytics.IN_DEFINITION": "Em definição",
    "hcm.analytics.IN_DRAFT": "Rascunho",
    "hcm.analytics.IN_PROGRESS": "Em andamento",
    "hcm.analytics.IN_REVISION": "Avaliação em revisão",
    "hcm.analytics.In_progress": "Em andamento",
    "hcm.analytics.Invalid_date": "Data inválida",
    "hcm.analytics.Issued_date": "Data de emissão",
    "hcm.analytics.Issuer_country": "País emissor",
    "hcm.analytics.Issuer_state": "Órgão emissor/UF",
    "hcm.analytics.Issuing_authority": "Órgão emissor",
    "hcm.analytics.Issuing_state": "UF do Órgão emissor",
    "hcm.analytics.JARDIM": "Jardim",
    "hcm.analytics.Jan_Mar": "Jan-Mar",
    "hcm.analytics.Job_position": "Cargo",
    "hcm.analytics.Jul_Sep": "Jul-Set",
    "hcm.analytics.LADEIRA": "Ladeira",
    "hcm.analytics.LAGO": "Lago",
    "hcm.analytics.LAGOA": "Lagoa",
    "hcm.analytics.LARGE": "Grande porte",
    "hcm.analytics.LARGO": "Largo",
    "hcm.analytics.LEADER": "Superior",
    "hcm.analytics.LEISURE_AND_BUSINESS_EVENTS": "Negócios de lazer e eventos",
    "hcm.analytics.LOTEAMENTO": "Loteamento",
    "hcm.analytics.LOW": "Baixo",
    "hcm.analytics.LOW_ATTENDANCE": "Reprovado por frequência",
    "hcm.analytics.Last_feedback_received_in": "Último feedback recebido em",
    "hcm.analytics.Leader": "Líder",
    "hcm.analytics.Led-people": "Liderados",
    "hcm.analytics.Load_more": "Carregar mais",
    "hcm.analytics.Locality": "Localidade",
    "hcm.analytics.MALE": "Masculino",
    "hcm.analytics.MARITAL_STATE": "Estado civil",
    "hcm.analytics.MARRIAGE": "Casamento",
    "hcm.analytics.MARRIED": "Casado",
    "hcm.analytics.MASTER": "Mestrado completo",
    "hcm.analytics.MEAT_AND_MEAT_PRODUCTS": "Carnes e derivados",
    "hcm.analytics.MEDIUM": "Médio",
    "hcm.analytics.MEDIUM_SIZED": "Médio porte",
    "hcm.analytics.MICRO": "Microempresa",
    "hcm.analytics.MIDDLE_SCHOOL_COMPLETE": "Ensino Fundamental Completo",
    "hcm.analytics.MIDDLE_SCHOOL_INCOMPLETE": "Do 6º ao 9º ano do Ensino Fundamental incompleto (antiga 5ª a 8ª série)",
    "hcm.analytics.MINING": "Mineração",
    "hcm.analytics.MISCELLANEOUS_SERVICES": "Serviços diversos",
    "hcm.analytics.MODULE_TYPE_APPOINTMENT": "Gestão do Ponto",
    "hcm.analytics.MODULE_TYPE_CAREER": "Gestão de Carreira",
    "hcm.analytics.MODULE_TYPE_CORPORATE_WALL": "Mural Corporativo",
    "hcm.analytics.MODULE_TYPE_MOODS": "Moods",
    "hcm.analytics.MODULE_TYPE_MY": "Meu Perfil",
    "hcm.analytics.MODULE_TYPE_PAYROLL": "Folha de Pagamento",
    "hcm.analytics.MODULE_TYPE_PERFORMANCE": "Gestão de Desempenho",
    "hcm.analytics.MODULE_TYPE_RECRUITMENT": "Gestão de Recrutamento e Seleção",
    "hcm.analytics.MODULE_TYPE_REMUNERATION": "Gestão de Remuneração",
    "hcm.analytics.MODULE_TYPE_TEAM": "Equipe",
    "hcm.analytics.MONTHLY": "Mensal",
    "hcm.analytics.MORRO": "Morro",
    "hcm.analytics.MOV_BEGIN_LEAVE": "Início do afastamento",
    "hcm.analytics.MOV_BEGIN_STABILITY": "Início de estabilidade",
    "hcm.analytics.MOV_BEGIN_VACATION": "Início de férias",
    "hcm.analytics.MOV_COMPANY_UPDATE": "Transferências de estabelecimento",
    "hcm.analytics.MOV_COST_CENTER_UPDATE": "Alterações de centro de custo",
    "hcm.analytics.MOV_DEPARTMENT_UPDATE": "Transferências de departamento",
    "hcm.analytics.MOV_END_LEAVE": "Final do afastamento",
    "hcm.analytics.MOV_END_STABILITY": "Final da estabilidade",
    "hcm.analytics.MOV_END_VACATION": "Final de férias",
    "hcm.analytics.MOV_FIRED": "Afastamentos",
    "hcm.analytics.MOV_ITEM_BEGIN_LEAVE": "Início de afastamento",
    "hcm.analytics.MOV_ITEM_BEGIN_STABILITY": "Início de estabilidade",
    "hcm.analytics.MOV_ITEM_COMPANY_CITY_STATE": "Cidade/Estado",
    "hcm.analytics.MOV_ITEM_COMPANY_CNPJ": "CNPJ",
    "hcm.analytics.MOV_ITEM_COMPANY_NAME": "Nome da empresa",
    "hcm.analytics.MOV_ITEM_COMPANY_TRANSFER_TYPE": "Tipo de transferência",
    "hcm.analytics.MOV_ITEM_COST_CENTER_NAME": "Centro de custo",
    "hcm.analytics.MOV_ITEM_DEPARTMENT_NAME": "Nome do departamento",
    "hcm.analytics.MOV_ITEM_DEPARTMENT_REASON": "Motivo",
    "hcm.analytics.MOV_ITEM_EMPLOYMENT_RELATIONSHIP_DESCRIPTION": "Vínculo empregatício",
    "hcm.analytics.MOV_ITEM_END_LEAVE": "Final do afastamento",
    "hcm.analytics.MOV_ITEM_END_STABILITY": "Final da estabilidade",
    "hcm.analytics.MOV_ITEM_ESTIMATED_END_LEAVE": "Previsão de retorno",
    "hcm.analytics.MOV_ITEM_JOB_POSITION_CBO": "CBO do cargo",
    "hcm.analytics.MOV_ITEM_JOB_POSITION_REASON": "Motivo",
    "hcm.analytics.MOV_ITEM_JOB_POSITION_TITLE": "Título do cargo",
    "hcm.analytics.MOV_ITEM_LEAVE_SITUATION": "Motivo do afastamento",
    "hcm.analytics.MOV_ITEM_SALARY_ADJUSTMENT_PERCENTAGE": "Percentual de ajuste",
    "hcm.analytics.MOV_ITEM_SALARY_PERFORMANCE_PERCENTAGE": "Percentual de performance",
    "hcm.analytics.MOV_ITEM_SALARY_REASON": "Motivo",
    "hcm.analytics.MOV_ITEM_SALARY_SPENDING_MONEY": "Valor do complemento",
    "hcm.analytics.MOV_ITEM_SALARY_TYPE": "Tipo do salário",
    "hcm.analytics.MOV_ITEM_SALARY_VALUE": "Valor do salário",
    "hcm.analytics.MOV_ITEM_SALARY_WAGE_CLASS_NAME": "Classe do salário",
    "hcm.analytics.MOV_ITEM_SALARY_WAGE_LEVEL_NAME": "Nível do salário",
    "hcm.analytics.MOV_ITEM_SALARY_WAGE_SCALE_NAME": "Escala",
    "hcm.analytics.MOV_ITEM_STABILITY_TYPE": "Tipo de estabilidade",
    "hcm.analytics.MOV_ITEM_WORKSHIFT_DESCRIPTION": "Descrição do turno",
    "hcm.analytics.MOV_ITEM_WORKSHIFT_NAME": "Turno",
    "hcm.analytics.MOV_ITEM_WORKSTATION_NAME": "Posto de trabalho",
    "hcm.analytics.MOV_ITEM_WORKSTATION_REASON": "Motivo",
    "hcm.analytics.MOV_JOB_POSITION_UPDATE": "Alterações de cargo",
    "hcm.analytics.MOV_NEW_EMPLOYMENT_RELATIONSHIP": "Alterações de vínculo empregatício",
    "hcm.analytics.MOV_SALARY_UPDATE": "Alterações salariais",
    "hcm.analytics.MOV_WORKSHIFT_UPDATE": "Alterações da jornada de trabalho",
    "hcm.analytics.MOV_WORKSTATION_UPDATE": "Alterações de posto de trabalho",
    "hcm.analytics.Media_dos_feedbacks_recebidos": "Média dos feedbacks recebidos",
    "hcm.analytics.Media_of_feedbacks_received": "Média dos feedbacks recebidos",
    "hcm.analytics.NACIONALITY": "Nacionalidade",
    "hcm.analytics.NAO_SE_APLICA": "Não se aplica",
    "hcm.analytics.NATURALITY": "Naturalidade",
    "hcm.analytics.NEPHEW_NIECE": "Sobrinho(a)",
    "hcm.analytics.NIS_desc": "Número de identificação do segurado (PIS/PASEP/NIT)",
    "hcm.analytics.NONE": "Sem faixa",
    "hcm.analytics.NOT_ELIGIBLE": "Não eligível",
    "hcm.analytics.NOT_INFORMED": "Não informdo",
    "hcm.analytics.NOT_STARTED": "Não iniciado",
    "hcm.analytics.NUCLEO": "Núcleo",
    "hcm.analytics.Nascida_em": "Nascida em",
    "hcm.analytics.Nascido_em": "Nascido em",
    "hcm.analytics.Nascimento": "Nascimento",
    "hcm.analytics.National_health_card": "Cartão nacional de saúde",
    "hcm.analytics.Number": "Número",
    "hcm.analytics.OIL_GAS_AND_FUEL": "Petróleo, gás e combustíveis",
    "hcm.analytics.OTHER": "Outros",
    "hcm.analytics.OTHERS": "Outros",
    "hcm.analytics.OUTROS": "Outros",
    "hcm.analytics.Oct_Dec": "Out-Dez",
    "hcm.analytics.PAIR": "Pares",
    "hcm.analytics.PAPER_AND_WOOD": "Papel e madeira",
    "hcm.analytics.PARENT": "Pai/Mãe",
    "hcm.analytics.PARENT_IN_LAW": "Sogro(a)",
    "hcm.analytics.PARQUE": "Parque",
    "hcm.analytics.PARTNER": "Companheiro(a)",
    "hcm.analytics.PASSARELA": "Passarela",
    "hcm.analytics.PATIO": "Pátio",
    "hcm.analytics.PENSIONERS": "Pensionista",
    "hcm.analytics.POSTGRADUATE": "Pós-Graduação completa",
    "hcm.analytics.PRACA": "Praça",
    "hcm.analytics.PRAIA": "Praia",
    "hcm.analytics.PROCESSED_FOODS": "Alimentos processados",
    "hcm.analytics.PROVIDER": "Fornecedor",
    "hcm.analytics.PUPIL": "Tutelado",
    "hcm.analytics.Paper_no": "Nº da folha",
    "hcm.analytics.Passport": "Passaporte",
    "hcm.analytics.Period": "Período",
    "hcm.analytics.Personal_contact": "Contatos",
    "hcm.analytics.Personal_documents": "Documentos pessoais",
    "hcm.analytics.Potencial": "Potencial",
    "hcm.analytics.Professional_certification": "Certificação profissional",
    "hcm.analytics.Professional_experience": "Experiência profissional",
    "hcm.analytics.QUADRA": "Quadra",
    "hcm.analytics.QUITTER": "Desistente",
    "hcm.analytics.RACE_AND_COLOR": "Raça e cor",
    "hcm.analytics.REAL": "Real",
    "hcm.analytics.RECANTO": "Recanto",
    "hcm.analytics.REGISTRATION_BANNS": "Registro de Proclamas",
    "hcm.analytics.REJECTED": "Recusado",
    "hcm.analytics.REJECTED_FEMALE": "Rejeitada",
    "hcm.analytics.RELEASED": "Liberada",
    "hcm.analytics.RELIGIOUS_MARRIAGE": "Casamento Religioso com efeito civil",
    "hcm.analytics.RESIDENCIAL": "Residencial",
    "hcm.analytics.RETAIL": "Varejo",
    "hcm.analytics.RETURNED_TO_ADJUSTMENTS": "Retornado para ajustes",
    "hcm.analytics.RETURN_INTEGRATION": "Integração retornada",
    "hcm.analytics.RG_desc": "Registro Geral",
    "hcm.analytics.RIC_desc": "Registro de identidade civil",
    "hcm.analytics.RODOVIA": "Rodovia",
    "hcm.analytics.RUA": "Rua",
    "hcm.analytics.Registration_date": "Data do registro",
    "hcm.analytics.Registry_name": "Nome do cartório",
    "hcm.analytics.Request_feedback": "Solicitar feedback",
    "hcm.analytics.Reservist_certificate": "Certificado de reservista",
    "hcm.analytics.Resultados": "Resultados",
    "hcm.analytics.Return_expected_on": "Previsão de retorno em",
    "hcm.analytics.SCHOLARITY": "Escolaridade",
    "hcm.analytics.SELF_EVALUATION": "Autoavaliação",
    "hcm.analytics.SERVIDOR_PUBLICO_AGENTE_PUBLICO": "Servidor Público - Agente Público",
    "hcm.analytics.SERVIDOR_PUBLICO_CONTRATO_TEMPORARIO": "Servidor Público - Contrato Temporário",
    "hcm.analytics.SERVIDOR_PUBLICO_EXERCENTE_DE_MANDATO_EFETIVO": "Servidor Público - Ejerce en Mandato Electivo",
    "hcm.analytics.SERVIDOR_PUBLICO_NAO_EFETIVO_DEMISSIVEL_AD_NUTUM_OU_ADMITIDO_POR_MEIO_DE_LEGISLACAO_ESPECIAL_NAO_REGIDO_PELA_CLT": "Servidor público não efetivo demissível ad nutum ou admitido por meio de legislação especial não regido pela CLT",
    "hcm.analytics.SERVIDOR_PUBLICO_OCUPANTE_CARGO_EXCLUSIVO_COMISSAO": "Servidor Público - Ocupante de Cargo exclusivo em comissão",
    "hcm.analytics.SERVIDOR_PUBLICO_TITULAR_DE_CARGO_EFETIVO": "Servidor Público - Titular de Cargo Efetivo",
    "hcm.analytics.SERVIDOR_PUBLICO_VINCULADO_A_RPPS_INDICADO_PARA_CONSELHO_OU_ORGAO_REPRESENTATIVO_NA_CONDICAO_DE_REPRESENTANTE_DO_GOVERNO_ORGAO_OU_ENTIDADE_DA_ADMINISTRACAO_PUBLICA": "Servidor Público vinculado a RPPS indicado para consejo o órgano representativo, en la condición de representante del gobierno, órgano o entidad de la administración pública.",
    "hcm.analytics.SERVIDOR_REGIDO_PELO_REGIME_JURIDICO_UNICO_E_MILITAR_VINCULADO_AO_REGIME_GERAL_DE_PREVIDENCIA_SOCIAL": "Servidor regido pelo regime jurídico único e militar vinculado ao regime geral de previdência social",
    "hcm.analytics.SERVIDOR_REGIDO_PELO_REGIME_JURIDICO_UNICO_E_MILITAR_VINCULADO_A_REGIME_PROPRIO_DE_PREVIDENCIA": "Servidor regido pelo regime jurídico único e militar vinculado a regime próprio de previdência",
    "hcm.analytics.SETOR": "Setor",
    "hcm.analytics.SIBLING": "Irmão(a)",
    "hcm.analytics.SINGLE": "Solteiro",
    "hcm.analytics.SITIO": "Sítio",
    "hcm.analytics.SITUATION_STAFF_REQUISITION": "SITUAÇÃO DAS REQUISIÇÕES DE PESSOAL",
    "hcm.analytics.SMALL": "Pequeno porte",
    "hcm.analytics.SON_DAUGHTER_IN_LAW": "Genro/Nora",
    "hcm.analytics.SPOUSE": "Cônjuge",
    "hcm.analytics.STEEL_AND_METAL": "Siderurgia e metalurgia",
    "hcm.analytics.STEPCHILD": "Enteado(a)",
    "hcm.analytics.STEPFATHER": "Padrasto",
    "hcm.analytics.STEPMOTHER": "Madrasta",
    "hcm.analytics.STILLBIRTH": "Natimorto",
    "hcm.analytics.SUBORDINATE": "Liderado",
    "hcm.analytics.SUSPENDED": "Suspenso",
    "hcm.analytics.Series": "Série",
    "hcm.analytics.Show_certificate": "Exibir certificado",
    "hcm.analytics.Situation": "Situação",
    "hcm.analytics.Solicitacao_de_0_1": "Solicitação de {{date}} ({{status}})",
    "hcm.analytics.Started_at_startDate": "Iniciado em {{startDate}}",
    "hcm.analytics.State": "UF",
    "hcm.analytics.TELECOMMUNICATIONS": "Telecomunicações",
    "hcm.analytics.TEMPORARILY_SUSPENDED": "Suspenso temporariamente",
    "hcm.analytics.TEXTILES": "Têxteis",
    "hcm.analytics.TO_LOWER_CASE": "para",
    "hcm.analytics.TRABALHADOR_AVULSO_NAO_PORTUARIO_INFORMACOES_CONTRATANTE": "Trabalhador Avulso - Não Portuário (Informação do Contratante)",
    "hcm.analytics.TRABALHADOR_AVULSO_NAO_PORTUARIO_INFORMACOES_SINDICATO": "Trabalhador Avulso - Não Portuário (Informação do Sindicato)",
    "hcm.analytics.TRABALHADOR_AVULSO_PORTUARIO": "Trabalhador Avulso - Portuário",
    "hcm.analytics.TRABALHADOR_AVULSO_TRABALHO_ADMINISTRADO_PELO_SINDICATO_DA_CATEGORIA_OU_PELO_ORGAO_GESTOR_DE_MAO_DE_OBRA_PARA_O_QUAL_E_DEVIDO_DEPOSITO_DE_FGTS": "Trabalhador avulso trabalho administrado pelo sindicato da categoria ou pelo órgão gestor de mão de obra para o qual e devido deposito de FGTS",
    "hcm.analytics.TRABALHADOR_DOMESTICO": "Trabalhador doméstico",
    "hcm.analytics.TRABALHADOR_NAO_VINCULADO_AO_RGPS_COM_DIREITO_AO_FGTS": "Trabalhador não vinculado ao RGPS com direito ao FGTS",
    "hcm.analytics.TRABALHADOR_RURAL_VINCULADO_A_EMPREGADOR_PESSOA_FISICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_LEI_N_5889_DE_1973_POR_PRAZO_DETERMINADO": "Trabalhador rural vinculado a empregador pessoa física por contrato de trabalho regido pela lei nº 5889 de 1973 por prazo determinado",
    "hcm.analytics.TRABALHADOR_RURAL_VINCULADO_A_EMPREGADOR_PESSOA_FISICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_LEI_N_5889_DE_1973_POR_PRAZO_INDETERMINADO": "Trabalhador rural vinculado a empregador pessoa física por contrato de trabalho regido pela lei nº 5889 de 1973 por prazo indeterminado",
    "hcm.analytics.TRABALHADOR_RURAL_VINCULADO_A_EMPREGADOR_PESSOA_JURIDICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_LEI_N_5889_DE_1973_POR_PRAZO_DETERMINADO": "Trabalhador rural vinculado a empregador pessoa jurídica por contrato de trabalho regido pela lei nº 5889 de 1973 por prazo determinado",
    "hcm.analytics.TRABALHADOR_RURAL_VINCULADO_A_EMPREGADOR_PESSOA_JURIDICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_LEI_N_5889_DE_1973_POR_PRAZO_INDETERMINADO": "Trabalhador rural vinculado a empregador pessoa jurídica por contrato de trabalho regido pela lei nº 5889 de 1973 por prazo indeterminado",
    "hcm.analytics.TRABALHADOR_TEMPORARIO_REGIDO_PELA_LEI_N_6019_DE_3_DE_JANEIRO_DE_1974": "Trabalhador temporário regido pela lei nº 6019 de 3 de janeiro de 1974",
    "hcm.analytics.TRABALHADOR_URBANO_VINCULADO_A_EMPREGADOR_PESSOA_FISICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_CLT_POR_PRAZO_DETERMINADO_OU_OBRA_CERTA": "Trabalhador urbano vinculado a empregador pessoa física por contrato de trabalho regido pela CLT por prazo determinado ou obra certa",
    "hcm.analytics.TRABALHADOR_URBANO_VINCULADO_A_EMPREGADOR_PESSOA_FISICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_CLT_POR_PRAZO_INDETERMINADO": "Trabalhador urbano vinculado a empregador pessoa física por contrato de trabalho regido pela CLT por prazo indeterminado",
    "hcm.analytics.TRABALHADOR_URBANO_VINCULADO_A_EMPREGADOR_PESSOA_JURIDICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_CLT_POR_PRAZO_INDETERMINADO": "Trabalhador urbano vinculado a empregador pessoa jurídica por contrato de trabalho regido pela CLT por prazo indeterminado",
    "hcm.analytics.TRABALHADOR_URBANO_VINCULADO_A_EMPREGADOR_PESSOA_JURIDICA_POR_CONTRATO_DE_TRABALHO_REGIDO_PELA_CLT_POR_TEMPO_DETERMINADO_OU_OBRA_CERTA": "Trabalhador urbano vinculado a empregador pessoa jurídica por contrato de trabalho regido pela CLT por tempo determinado ou obra certa",
    "hcm.analytics.TRANSFERRED": "Transferido de instituição/curso",
    "hcm.analytics.TRANSPORT_SECTOR": "Setor de transporte",
    "hcm.analytics.TRAVESSA": "Travessa",
    "hcm.analytics.TRECHO": "Trecho",
    "hcm.analytics.TREVO": "Trevo",
    "hcm.analytics.TRUSTEED": "Curatelado",
    "hcm.analytics.Telephone_contacts": "Contatos telefônicos",
    "hcm.analytics.Term_number": "Nº do termo",
    "hcm.analytics.Trade_name": "Nome fantasia",
    "hcm.analytics.Trainings": "Treinamentos",
    "hcm.analytics.Type": "Tipo",
    "hcm.analytics.Type_certificate": "Certidão de {{type}}",
    "hcm.analytics.Type_of_establishment": "Tipo do estabelecimento",
    "hcm.analytics.UNCLE_AUNT": "Tio/Tia",
    "hcm.analytics.UNDER_ANALYSIS": "Em avaliação",
    "hcm.analytics.Ultimo_feedback_recebido_em": "Último feedback recebido em",
    "hcm.analytics.VALE": "Vale",
    "hcm.analytics.VARIOUS_MATERIALS": "Materiais diversos",
    "hcm.analytics.VEREDA": "Vereda",
    "hcm.analytics.VIA": "Via",
    "hcm.analytics.VIADUTO": "Viaduto",
    "hcm.analytics.VIELA": "Viela",
    "hcm.analytics.VILA": "Vila",
    "hcm.analytics.Vacation_session": "Férias",
    "hcm.analytics.Voter_registration": "Título de Eleitor",
    "hcm.analytics.WAITING_APPRAISAL_APPROVAL": "Aguardando aprovação do avaliado",
    "hcm.analytics.WAITING_APPRAISAL_APPROVAL_MANAGER": "Aguardando aprovação do gestor",
    "hcm.analytics.WAITING_EFETIVATION": "Em processamento",
    "hcm.analytics.WAITING_GOAL_APPROVAL": "Aguardando aprovação das metas do avaliado",
    "hcm.analytics.WAITING_GOAL_APPROVAL_REVISION": "Aguardando aprovação das metas revisadas",
    "hcm.analytics.WAITING_INTEGRATION": "Em processamento",
    "hcm.analytics.WATER_GAS_AND_SANITATION": "Água, gás e saneamento",
    "hcm.analytics.WEEKLY": "Semanal",
    "hcm.analytics.WHITE": "Branca",
    "hcm.analytics.WITHOUT": "Nenhum",
    "hcm.analytics.With_conclusion_on_endDate": "Com término em {{endDate}}",
    "hcm.analytics.With_expected_conclusion_on_endDate": "Com término previsto em {{endDate}}",
    "hcm.analytics.Work_schedule": "Escala de trabalho",
    "hcm.analytics.Workload": "Carga horária",
    "hcm.analytics.Workload_of_duration": "Com carga horária de {{duration}}",
    "hcm.analytics.Write_feedback": "Escrever feedback",
    "hcm.analytics.YELLOW": "Amarela",
    "hcm.analytics.abr_jun": "Abr-Jun",
    "hcm.analytics.actions": "Ações",
    "hcm.analytics.active": "Ativa",
    "hcm.analytics.add": "Adicionar",
    "hcm.analytics.add_candidate_for_succession": "Adicionar candidato à sucessão",
    "hcm.analytics.address_data_complement": "Complemento",
    "hcm.analytics.address_data_number": "Número",
    "hcm.analytics.address_data_public_city": "Cidade/UF",
    "hcm.analytics.address_data_public_neighborhood": "Bairro",
    "hcm.analytics.address_data_public_place": "Logradouro",
    "hcm.analytics.address_data_public_postal_code": "CEP",
    "hcm.analytics.address_data_title": "Endereço",
    "hcm.analytics.advanced_filter_general_tab_title": "Geral",
    "hcm.analytics.advanced_filter_recruitment_tab_title": "Recrutamento e Seleção",
    "hcm.analytics.advanced_filter_title": "Filtros",
    "hcm.analytics.advanced_filter_unavailable_service": "O serviço de filtro está indisponível no momento e as informações apresentadas não são as mais recentes. Tente novamente mais tarde.",
    "hcm.analytics.analytics_led_breadcrumb": "Analytics do liderado",
    "hcm.analytics.analytics_menu_tour_description": "Além do acesso pelo menu, através deste botão você também pode acessar todas as telas de Analytics disponíveis para o seu usuário.",
    "hcm.analytics.analytics_menu_tour_title": "Telas de Analytics",
    "hcm.analytics.analytics_moods_breadcrumb": "Analytics do moods",
    "hcm.analytics.analytics_payroll_breadcrumb": "Analytics da folha",
    "hcm.analytics.analytics_performance_breadcrumb": "Analytics do desempenho",
    "hcm.analytics.analytics_recruitment_breadcrumb": "Analytics do Gestão de Recrutamento e Seleção",
    "hcm.analytics.analytics_remuneration_breadcrumb": "Analytics da remuneração",
    "hcm.analytics.analytics_team_breadcrumb": "Analytics da equipe",
    "hcm.analytics.and_average_of_average": "e com média de {{average}}",
    "hcm.analytics.appointment_overtime-hours-in-calculation-period_estimated_cost": "Custo estimado",
    "hcm.analytics.appointment_overtime-hours-in-calculation-period_hours": "Horas extras",
    "hcm.analytics.appointment_tab": "Ponto",
    "hcm.analytics.approved_by_the_hr_department": "Aprovadas pelo RH",
    "hcm.analytics.approved_candidates_external": "Candidatos externos",
    "hcm.analytics.approved_candidates_internal": "Candidatos internos",
    "hcm.analytics.attended": "Atendidos",
    "hcm.analytics.average_by_employee": "Média por colaborador",
    "hcm.analytics.average_salary": "Média salarial",
    "hcm.analytics.average_salary_team": "Média salarial da minha equipe",
    "hcm.analytics.average_salary_years_company": "Tempo de empresa (Anos)",
    "hcm.analytics.average_satisfaction": "Pontuação da empresa por pulso",
    "hcm.analytics.average_time_increase": "Tempo médio de aumento",
    "hcm.analytics.average_time_salary_increase": "Tempo médio de aumento salarial",
    "hcm.analytics.bank_data_account": "Conta",
    "hcm.analytics.bank_data_agency": "Agência",
    "hcm.analytics.bank_data_bank": "Banco",
    "hcm.analytics.bank_data_title": "Dados bancários",
    "hcm.analytics.bank_ta_agency": "Agência",
    "hcm.analytics.birthday_person_title": "Aniversariantes",
    "hcm.analytics.branch": "ramal",
    "hcm.analytics.breadcrumb_tour_description": "Para voltar para a página anterior basta clicar no link. Este é o caminho que você percorreu no sistema.",
    "hcm.analytics.breadcrumb_tour_title": "Voltar página",
    "hcm.analytics.btn_label_all_leds": "Todos os liderados",
    "hcm.analytics.btn_label_my_leds": "Liderados diretos",
    "hcm.analytics.business_birthday_title": "Aniversariantes de empresa",
    "hcm.analytics.business_birthday_year": "ano",
    "hcm.analytics.business_birthday_years": "anos",
    "hcm.analytics.business_emails": "E-mails comerciais",
    "hcm.analytics.cancel": "Cancelar",
    "hcm.analytics.card_direct_descendants": "Colaboradores da minha equipe",
    "hcm.analytics.card_empty_description": "Você pode cadastrar as informações e tentar novamente.",
    "hcm.analytics.card_empty_title": "Nenhum resultado encontrado.",
    "hcm.analytics.card_error_description": "Você pode atualizar a página e, caso o erro continue, deve entrar em contato com o Administrador do sistema.",
    "hcm.analytics.card_error_title": "Erro na busca das informações.",
    "hcm.analytics.career_career_objectives": "Objetivos de carreira",
    "hcm.analytics.career_careerplan": "Plano de Carreira",
    "hcm.analytics.career_group_title": "Carreira",
    "hcm.analytics.career_succession_plan_candidats": "Candidatos a sucessão",
    "hcm.analytics.career_tab": "Carreira",
    "hcm.analytics.chain_of_command": "Cadeia de comando",
    "hcm.analytics.climate_survey_research_interval": "Intervalo da pesquisa",
    "hcm.analytics.climate_survey_research_situation": "Situação da pesquisa",
    "hcm.analytics.close": "Fechar",
    "hcm.analytics.close_tour_tooltip": "Fechar",
    "hcm.analytics.colleagues": "Colegas",
    "hcm.analytics.comments_quantity": "Quantidade de comentários",
    "hcm.analytics.company": "Empresa",
    "hcm.analytics.completed": "Concluídas",
    "hcm.analytics.config_dashboard_competency_evaluation": "Avaliação de competência",
    "hcm.analytics.config_dashboard_job_position_time": "Tempo no cargo",
    "hcm.analytics.config_dashboard_result_evaluation": "Avaliação de resultado",
    "hcm.analytics.contracts_button_tour_description": "Navegue entre seus contratos ativos através deste botão para visualizar as informações relativas a cada um deles.",
    "hcm.analytics.contracts_button_tour_title": "Contratos",
    "hcm.analytics.contratos_com_prazo_determinado_a_vencer_nos_proximos_90_dias": "Contratos com prazo determinado a vencer nos próximos 90 dias",
    "hcm.analytics.corporate_wall_tab": "Mural Corporativo",
    "hcm.analytics.corporate_wall_tour_description": "É no mural corporativo que estão as informações gerais da empresa, como aniversários dos colegas e de empresa e também as movimentações (entradas e saídas), caso estejam disponíveis.",
    "hcm.analytics.corporate_wall_tour_title": "Mural corporativo",
    "hcm.analytics.current_salary": "Salário atual",
    "hcm.analytics.curriculums_incomplete": "Currículos incompletos",
    "hcm.analytics.curriculums_registered": "Currículos cadastrados",
    "hcm.analytics.dashboard_appointment_absenteeism": "Absenteísmo",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_absences": "Faltas",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_aid_disease": "Auxílio doença",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_association_mandate": "Mandato sindical",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_citizen_company_maternity": "Maternidade empresa cidadã",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_collective_holiday": "Férias coletivas",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_license_without_pay": "Licença sem remuneração",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_maternity_license": "Licença maternidade",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_maternity_license_inss": "Licença maternidade INSS",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_medical_license_paid_by_company": "Licença médica paga pela empresa",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_military_service": "Serviço militar",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_notice_worked": "Aviso prévio trabalhado",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_overtime": "Horas extras",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_paid_by_company_license": "Licença remunerada pela empresa",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_paid_by_employee_license": "Licença remunerada pelo colaborador",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_paternity_license": "Licença paternidade",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_readiness": "Sobreaviso/Prontidão",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_retirement": "Aposentadoria",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_time_tracking": "Apuração de ponto",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_used_vacation_taken": "Férias gozadas já adiantadas",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_vacation": "Férias",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_work_accident": "Acidente de trabalho",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_work_accident_license_paid_by_company": "Licença acidente de trabalho pago pela empresa",
    "hcm.analytics.dashboard_appointment_absenteeism_legend_working": "Trabalhando",
    "hcm.analytics.dashboard_appointment_absenteeism_y_title": "Absenteísmo (horas)",
    "hcm.analytics.dashboard_appointment_average_time_plotline": "Média de {0}h",
    "hcm.analytics.dashboard_appointment_average_time_title": "Média de horas",
    "hcm.analytics.dashboard_appointment_comp_time_balance_employee_current_balance": "Saldo atual",
    "hcm.analytics.dashboard_appointment_comp_time_balance_employee_title": "Saldo",
    "hcm.analytics.dashboard_appointment_comp_time_balance_label": "Saldo na data atual",
    "hcm.analytics.dashboard_appointment_comp_time_balance_manager_negative_balance": "Negativo",
    "hcm.analytics.dashboard_appointment_comp_time_balance_manager_positive_balance": "Positivo",
    "hcm.analytics.dashboard_appointment_comp_time_balance_manager_title": "Saldos",
    "hcm.analytics.dashboard_appointment_comp_time_balance_title": "Saldo atual",
    "hcm.analytics.dashboard_appointment_comp_time_discount": "descontar",
    "hcm.analytics.dashboard_appointment_comp_time_hour_discount_label": "Descontos no mês",
    "hcm.analytics.dashboard_appointment_comp_time_hour_discount_title": "Total de descontos",
    "hcm.analytics.dashboard_appointment_comp_time_hour_month_discount_title": "Descontos no mês",
    "hcm.analytics.dashboard_appointment_comp_time_hour_month_receive_title": "Pagamentos no mês",
    "hcm.analytics.dashboard_appointment_comp_time_hour_month_title": "Horas de banco no mês",
    "hcm.analytics.dashboard_appointment_comp_time_hour_pay_discount_discount": "Descontos",
    "hcm.analytics.dashboard_appointment_comp_time_hour_pay_discount_pay": "Pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_hour_pay_discount_title": "Fechamento",
    "hcm.analytics.dashboard_appointment_comp_time_hour_pay_label": "Pagamento no mês",
    "hcm.analytics.dashboard_appointment_comp_time_hour_pay_title": "Total de pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_disc_title": "Projeção de descontos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_discount_legend": "Descontos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_discount_title": "Projeção de descontos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_hours_employee_hour_discount": "Descontos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_hours_employee_hour_receive": "Pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_hours_employee_title": "Projeção de horas",
    "hcm.analytics.dashboard_appointment_comp_time_proj_my_title": "Projeção de horas no mês",
    "hcm.analytics.dashboard_appointment_comp_time_proj_pay_discount_title": "Projeção de horas",
    "hcm.analytics.dashboard_appointment_comp_time_proj_pay_legend": "Pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_pay_title": "Projeção de pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_proj_receive_title": "Projeção de pagamentos",
    "hcm.analytics.dashboard_appointment_comp_time_receive": "receber",
    "hcm.analytics.dashboard_appointment_compesatory_time_title": "Banco de horas",
    "hcm.analytics.dashboard_appointment_hour_in_value_hour_title": "Horas",
    "hcm.analytics.dashboard_appointment_hour_in_value_value_title": "Valor",
    "hcm.analytics.dashboard_appointment_inc_just_accepted": "Aceitas",
    "hcm.analytics.dashboard_appointment_inc_just_justify": "Pendentes com gestor",
    "hcm.analytics.dashboard_appointment_inc_just_not_justify": "Não justificadas",
    "hcm.analytics.dashboard_appointment_inc_just_reject": "Recusadas",
    "hcm.analytics.dashboard_appointment_incident": "Incidentes",
    "hcm.analytics.dashboard_appointment_incident_competence_summary_title": "Total de incidentes",
    "hcm.analytics.dashboard_appointment_incident_justification_series": "Status das justificativas",
    "hcm.analytics.dashboard_appointment_incident_justification_title": "Justificativas",
    "hcm.analytics.dashboard_appointment_incident_more_occurrences_title": "Mais ocorrências",
    "hcm.analytics.dashboard_appointment_info_value_in_cash": "Este valor é uma previsão e pode variar de acordo com a parametrização e uso do sistema. No cálculo são considerados somente colaboradores mensalistas e horistas.",
    "hcm.analytics.dashboard_appointment_pendecy_title": "Acerto",
    "hcm.analytics.dashboard_appointment_time_adjust_pend_employee_label_expire": "Vence a partir de {0}",
    "hcm.analytics.dashboard_appointment_time_adjust_pend_employee_label_expired": "Vencidas desde {0}",
    "hcm.analytics.dashboard_appointment_time_adjust_pend_employee_label_no_pendency": "Nenhuma pendência de acerto",
    "hcm.analytics.dashboard_appointment_time_adjust_pend_employee_title": "Pendências de acerto",
    "hcm.analytics.dashboard_appointment_time_title": "Horas",
    "hcm.analytics.dashboard_appointment_total_time_extra": "Horas extras",
    "hcm.analytics.dashboard_appointment_total_time_not_work_time": "Horas não trabalhadas",
    "hcm.analytics.dashboard_appointment_total_time_title": "Total de horas",
    "hcm.analytics.dashboard_appointment_total_time_work_lack": "Faltas",
    "hcm.analytics.dashboard_appointment_total_time_work_leave": "Afastamentos",
    "hcm.analytics.dashboard_appointment_total_time_work_time": "Horas trabalhadas",
    "hcm.analytics.dashboard_appointment_withdrawal": "Afastamentos",
    "hcm.analytics.dashboard_average_promotion_time": "Tempo médio de promoção",
    "hcm.analytics.dashboard_average_promotion_time_salary_years_company": "Tempo de empresa (Anos)",
    "hcm.analytics.dashboard_career_workstation-key-position-summary_key_position": "Posições com candidato",
    "hcm.analytics.dashboard_career_workstation-key-position-summary_key_position_without_successors_mapped": "Posições sem candidato",
    "hcm.analytics.dashboard_career_workstation-key-position-summary_title": "Resumo das posições-chave",
    "hcm.analytics.dashboard_competence_appraisal_title": "Avaliação por competências",
    "hcm.analytics.dashboard_competence_evaluation_chart_title": "Resultado por competência",
    "hcm.analytics.dashboard_competence_evaluation_chart_tooltip": "Nota do conceito {{conceito}} <br> Conceito {{nome}}",
    "hcm.analytics.dashboard_competence_evaluation_title": "Resultado geral das avaliações",
    "hcm.analytics.dashboard_competence_evaluations_results_title": "Resultados",
    "hcm.analytics.dashboard_competency_assessment_title": "Avaliação por competências",
    "hcm.analytics.dashboard_current_employment_situation_title": "Situação atual do contrato de trabalho",
    "hcm.analytics.dashboard_detailed": "Detalhar gráfico",
    "hcm.analytics.dashboard_educational_level": "Nível de escolaridade da equipe",
    "hcm.analytics.dashboard_evaluated_proficiency_level_title": "Colaboradores por conceito",
    "hcm.analytics.dashboard_evaluation-status": "Status das avaliações",
    "hcm.analytics.dashboard_feedback_requests": "Solicitações de feedback - Evolução mensal",
    "hcm.analytics.dashboard_feedbacks_average_card_title": "Média dos últimos 12 meses",
    "hcm.analytics.dashboard_feedbacks_average_title": "Feedbacks recebidos",
    "hcm.analytics.dashboard_feedbacks_received_led": "Feedbacks recebidos",
    "hcm.analytics.dashboard_general_tile": "Geral",
    "hcm.analytics.dashboard_manager_jobs_by_responsible": "Vagas por responsável",
    "hcm.analytics.dashboard_manager_label_manager_wage_data": "Resumo salarial da equipe",
    "hcm.analytics.dashboard_manager_label_scheduled_raises": "Aumentos Programados",
    "hcm.analytics.dashboard_manager_label_updates_in_approval": "Aumentos em aprovação",
    "hcm.analytics.dashboard_manager_label_wage_mass": "Massa salarial",
    "hcm.analytics.dashboard_manager_score_by_pulse_title": "Pontuação por pulso",
    "hcm.analytics.dashboard_medium_hiring_time_title": "Tempo médio de contratação",
    "hcm.analytics.dashboard_monitor_team_goals_title": "Plano de desenvolvimento individual",
    "hcm.analytics.dashboard_month_evolution_effective": "Efetivo por tipo de contrato",
    "hcm.analytics.dashboard_monthly_hired_fired": "Admissões e desligamentos",
    "hcm.analytics.dashboard_movimentations": "Movimentações",
    "hcm.analytics.dashboard_movimentations_dismissals": "Demissões",
    "hcm.analytics.dashboard_movimentations_hires": "Admissões",
    "hcm.analytics.dashboard_movimentations_moves": "Transferências",
    "hcm.analytics.dashboard_payroll_payslip_competency": "Competência",
    "hcm.analytics.dashboard_payroll_payslip_payment_date": "Data de pagamento",
    "hcm.analytics.dashboard_payroll_payslip_salary": "Valor líquido",
    "hcm.analytics.dashboard_payroll_payslip_title": "Demonstrativo de pagamento",
    "hcm.analytics.dashboard_payroll_payslip_type": "Tipo de cálculo",
    "hcm.analytics.dashboard_payroll_payslip_type_ADIANTAMENTO_DECIMO_TERCEIRO_SALARIO": "Adiantamento 13° salário",
    "hcm.analytics.dashboard_payroll_payslip_type_ADIANTAMENTO_SALARIAL": "Adiantamento salarial",
    "hcm.analytics.dashboard_payroll_payslip_type_CALCULO_MENSAL": "Mensal",
    "hcm.analytics.dashboard_payroll_payslip_type_COMPLEMENTAR_DISSIDIO": "Complementar de dissídio",
    "hcm.analytics.dashboard_payroll_payslip_type_COMPLEMENTAR_RESCISAO": "Complementar rescisão",
    "hcm.analytics.dashboard_payroll_payslip_type_DECIMO_TERCEIRO_SALARIO_INTEGRAL": "13° Salário integral",
    "hcm.analytics.dashboard_payroll_payslip_type_ESPECIAIS": "Especiais",
    "hcm.analytics.dashboard_payroll_payslip_type_FOLHA_COMPLEMENTAR": "Folha complementar",
    "hcm.analytics.dashboard_payroll_payslip_type_GRATIFICACAO": "Gratificação",
    "hcm.analytics.dashboard_payroll_payslip_type_PAGAMENTO_DISSIDIO": "Pagamento de dissídio",
    "hcm.analytics.dashboard_payroll_payslip_type_PARTICIPACAO_LUCROS": "Participação nos lucros",
    "hcm.analytics.dashboard_payroll_payslip_type_PRIMEIRA_QUINZENA": "Primeira quinzena",
    "hcm.analytics.dashboard_payroll_payslip_type_PRIMEIRA_SEMANA": "Primeira semana",
    "hcm.analytics.dashboard_payroll_payslip_type_RECLAMATORIA_TRABALHISTA": "Reclamatória trabalhista",
    "hcm.analytics.dashboard_payroll_payslip_type_SEGUNDA_QUINZENA": "Segunda quinzena",
    "hcm.analytics.dashboard_payroll_payslip_type_SEMANA_INTERMEDIARIA": "Semana intermediária",
    "hcm.analytics.dashboard_payroll_payslip_type_ULTIMA_SEMANA": "Última semana",
    "hcm.analytics.dashboard_payroll_payslip_type_PAGAMENTO_INTERMITENTE": "Pagamento intermitente",
    "hcm.analytics.dashboard_payroll_vacation_complete": "Vencimento de 90 até 180 dias",
    "hcm.analytics.dashboard_payroll_vacation_expired": "Vencidos",
    "hcm.analytics.dashboard_payroll_vacation_title": "Períodos concessivos de férias",
    "hcm.analytics.dashboard_payroll_vacation_to_expired": "A vencer nos próximos 90 dias",
    "hcm.analytics.dashboard_pending_proposals_portlet_title": "Propostas pendentes",
    "hcm.analytics.dashboard_performance_evaluation_tile": "Avaliação de desempenho",
    "hcm.analytics.dashboard_performance_statistic_expected_achievement": "Atingimento esperado",
    "hcm.analytics.dashboard_performance_statistic_legend_of_achievement": "De atingimento",
    "hcm.analytics.dashboard_performance_statistic_results_from_my_team": "Avaliação de resultados da minha equipe",
    "hcm.analytics.dashboard_performance_statistic_x_title_individual": "Individual",
    "hcm.analytics.dashboard_readiness_level_title": "Nível de prontidão dos candidatos à sucessão",
    "hcm.analytics.dashboard_recruitment_workstation-key-position-summary_key_position": "Posições com candidato",
    "hcm.analytics.dashboard_recruitment_workstation-key-position-summary_key_position_without_successors_mapped": "Posições sem candidato",
    "hcm.analytics.dashboard_recruitment_workstation-key-position-summary_title": "Resumo das posições-chave",
    "hcm.analytics.dashboard_remuneration_vs_performance_caption_button": "Legenda",
    "hcm.analytics.dashboard_remuneration_vs_performance_caption_description": "As cores dos quadrantes da legenda são as mesmas dos ícones (● e ▲) e seguem a escala de criticidade.",
    "hcm.analytics.dashboard_remuneration_vs_performance_caption_label": "Legenda",
    "hcm.analytics.dashboard_risk_of_team_loss_high_risk_label": "Alto risco",
    "hcm.analytics.dashboard_risk_of_team_loss_low_risk_label": "Baixo risco",
    "hcm.analytics.dashboard_risk_of_team_loss_medium_risk_label": "Médio risco",
    "hcm.analytics.dashboard_risk_of_team_loss_title": "Risco de perda da equipe",
    "hcm.analytics.dashboard_salary_evolution_last_first_month_tooltip": "Representa a massa salarial do mês",
    "hcm.analytics.dashboard_salary_evolution_others_tooltip": "Representa os aumentos concedidos no mês",
    "hcm.analytics.dashboard_salary_evolution_portlet_title": "Histórico salarial",
    "hcm.analytics.dashboard_salary_evolution_portlet_tooltip_message_body": "{{percentage}}% em {{date}}, <strong>Motivo:</strong> {{reason}}",
    "hcm.analytics.dashboard_salary_evolution_portlet_tooltip_message_header": "<strong>Percentual</strong>",
    "hcm.analytics.dashboard_salary_framing_title": "Enquadramento Salarial",
    "hcm.analytics.dashboard_salary_framing_tooltip": "colaboradores",
    "hcm.analytics.dashboard_salary_framing_y_title": "Percentual de colaboradores",
    "hcm.analytics.dashboard_salary_increase_ranking_need_configuration": "Os indicadores devem ser configurados pelo RH.",
    "hcm.analytics.dashboard_salary_update_year_card_employees_count": "Colaboradores com alterações",
    "hcm.analytics.dashboard_salary_update_year_card_percentage_salary_updates": "Percentual de aumento",
    "hcm.analytics.dashboard_salary_update_year_card_total_salary_updates": "Total de aumentos",
    "hcm.analytics.dashboard_time_adjustment_current_state": "Status atual dos acertos",
    "hcm.analytics.dashboard_time_adjustment_current_state_pending_employee": "Pendente com o colaborador",
    "hcm.analytics.dashboard_time_adjustment_current_state_pending_manager": "Pendente com o gestor",
    "hcm.analytics.dashboard_time_adjustment_emptyNoClockEvent": "Este mês ainda não foi apurado.",
    "hcm.analytics.dashboard_time_adjustment_emptyWithClockEvent": "Nenhuma pendência de acerto encontrada no mês.",
    "hcm.analytics.warning_hintMonitor": "Este analytics difere os colaboradores que possuem registros do tipo marcação ou acesso, com os que não possuem marcações destes tipos no dia. É possível que existam marcações ainda não sincronizadas com a base",
    "hcm.analytics.text_attendanceMonitor": "Monitor De Presença",
    "hcm.analytics.text_withmark": "Com marcação",
    "hcm.analytics.text_withoutmark": "Sem marcação",
    "hcm.analytics.dashboard_time_adjustment_pendency_finalized": "Finalizadas",
    "hcm.analytics.dashboard_time_adjustment_pendency_pending": "Pendentes",
    "hcm.analytics.dashboard_time_adjustment_pendency_title": "Pendências de acerto",
    "hcm.analytics.dashboard_todays_journey_clocking_events": "Marcações:",
    "hcm.analytics.dashboard_todays_journey_finished": "Jornada encerrada",
    "hcm.analytics.dashboard_todays_journey_preview_to_leave": "Saída prevista",
    "hcm.analytics.dashboard_todays_journey_remaining_time": "Tempo restante",
    "hcm.analytics.dashboard_todays_journey_title": "Jornada de hoje",
    "hcm.analytics.dashboard_use_of_candidates": "Aproveitamento de candidatos",
    "hcm.analytics.dashboard_vacancies_number": "Quantidade de vagas",
    "hcm.analytics.dashboard_wage_average_among_employees": "Entre colaboradores",
    "hcm.analytics.dashboard_wage_average_among_men": "Entre homens",
    "hcm.analytics.dashboard_wage_average_among_women": "Entre mulheres",
    "hcm.analytics.dashboard_wage_average_portlet_title": "Média salarial da empresa",
    "hcm.analytics.dashboard_wage_average_team_portlet_title": "Média salarial da equipe",
    "hcm.analytics.dashboard_waiting_approval_proposals_portlet_title": "Propostas pendentes de aprovação",
    "hcm.analytics.dashboard_work_force_generation": "Força de trabalho por Geração",
    "hcm.analytics.data_not_being_filtered": "Os dados apresentados não consideram o filtro aplicado.",
    "hcm.analytics.day_s": "dia(s)",
    "hcm.analytics.days": "Dias",
    "hcm.analytics.defined": "Definidos",
    "hcm.analytics.department": "Departamento",
    "hcm.analytics.detail": "Detalhar",
    "hcm.analytics.detail_tour_description": "Este botão permite que você visualize mais informações sobre o assunto desejado. Nele é possível navegar pelas demais telas e realizar outras ações como solicitar férias por exemplo.",
    "hcm.analytics.detail_tour_title": "Ver detalhes",
    "hcm.analytics.details": "Ver detalhes",
    "hcm.analytics.details_indicators": "Detalhes dos indicadores",
    "hcm.analytics.did_not_reach_minimum_number_of_answer_tickets": "Pontuação não alterada pois o número mínimo<br> de 3 respondentes não foi atingido.",
    "hcm.analytics.dimension_satisfaction": "Pontuação atual da empresa por dimensão",
    "hcm.analytics.dimensions": "Dimensões",
    "hcm.analytics.done_tour_button": "Finalizar",
    "hcm.analytics.duration_hour": "{{duration}} hora",
    "hcm.analytics.duration_hours": "{{duration}} horas",
    "hcm.analytics.edit": "Editar",
    "hcm.analytics.employee": "Colaborador",
    "hcm.analytics.employee_detail": "Detalhes do colaborador",
    "hcm.analytics.employee_photo": "Foto do colaborador",
    "hcm.analytics.employees": "Colaboradores",
    "hcm.analytics.end_tour_description": "Você concluiu o tour pelas funcionalidades da tela de {{analyticType}}. Para saber mais consulte o <a href=\"https://documentacao.senior.com.br/seniorxplatform/manual-do-usuario/hcm/\">manual do usuário</a>.",
    "hcm.analytics.engage": "Engajamento",
    "hcm.analytics.enum_ModuleType_APPOINTMENT": "Gestão do Ponto",
    "hcm.analytics.enum_ModuleType_PAYROLL": "Folha de Pagamento",
    "hcm.analytics.enum_ModuleType_PERFORMANCE": "Gestão de Desempenho",
    "hcm.analytics.enum_ModuleType_RECRUITMENT": "Gestão de Recrutamento e Seleção",
    "hcm.analytics.enum_ModuleType_REMUNERATION": "Gestão de Remuneração",
    "hcm.analytics.enum_ModuleType_TEAM": "Equipe",
    "hcm.analytics.evolution_performance_level_current_cycle_scale": "Escala deste ciclo",
    "hcm.analytics.evolution_performance_level_current_scale": "Escala atual",
    "hcm.analytics.evolution_performance_level_title": "Evolução do nível de desempenho",
    "hcm.analytics.expired_next_30_days": "A vencer nos próximos 30 dias",
    "hcm.analytics.favorite_2_tour_description": "Acesse rapidamente as suas informações favoritas na aba Resumo.",
    "hcm.analytics.favorite_empty_description": "Clique na estrela para favoritar os cards do analytics e visualizá-los neste resumo.",
    "hcm.analytics.favorite_empty_title": "Nenhum favorito encontrado.",
    "hcm.analytics.favorite_tooltip": "Favoritar",
    "hcm.analytics.favorite_tour_description": "Com este recurso você pode favoritar os cards considerados mais relevantes e consultá-los de forma rápida e fácil pela guia Resumo.",
    "hcm.analytics.favorite_tour_title": "Favoritar os cards",
    "hcm.analytics.favorites": "Favoritos",
    "hcm.analytics.features_tab": "Características",
    "hcm.analytics.feedback": "Feedback",
    "hcm.analytics.feedback_recebido_nos": "Feedback recebido nos",
    "hcm.analytics.feedback_recebido_nos_ultimos_30_dias": "Feedback recebido nos últimos 30 dias",
    "hcm.analytics.feedback_received_the_last_30_days": "Recebidos nos últimos 30 dias",
    "hcm.analytics.feedbacks": "Feedbacks",
    "hcm.analytics.feedbacks_recebidos": "Feedbacks recebidos",
    "hcm.analytics.feedbacks_received_title": "Feedbacks recebidos",
    "hcm.analytics.filter_team_tour_description": "Utilize os filtros para encontrar rapidamente as informações da sua equipe e obter mais detalhes. Ao acessar uma tela pelo botão Ver detalhes esses filtros também serão considerados.",
    "hcm.analytics.filter_team_tour_title": "Filtrar dados",
    "hcm.analytics.fired": "Desligamentos",
    "hcm.analytics.formatted_days": "{0} dia(s)",
    "hcm.analytics.formatted_years": "{0} ano(s)",
    "hcm.analytics.from_startdate_to_enddate": "De {{startdate}} a {{enddate}}",
    "hcm.analytics.from_startdate_until_enddate": "De {{startDate}} até {{endDate}}",
    "hcm.analytics.generation_baby_boom": "Baby Boomer",
    "hcm.analytics.generation_great_generation": "Geração Grandiosa",
    "hcm.analytics.generation_unknown": "Desconhecido",
    "hcm.analytics.generation_x_generation": "Geração X",
    "hcm.analytics.generation_y_generation": "Geração Y",
    "hcm.analytics.generation_z_generation": "Geração Z",
    "hcm.analytics.go_back": "Voltar",
    "hcm.analytics.goal_type": "Tipo de objetivo",
    "hcm.analytics.goals_count_by_state_title": "Planos de desenvolvimento",
    "hcm.analytics.high": "Alto",
    "hcm.analytics.hired": "Admissões",
    "hcm.analytics.identification": "Identificação",
    "hcm.analytics.in_progress": "Em andamento",
    "hcm.analytics.inactive": "Inativa",
    "hcm.analytics.indicator": "Indicador",
    "hcm.analytics.indirect_subordinates": "Liderados indiretos",
    "hcm.analytics.individual_development_plan": "Plano de desenvolvimento Individual",
    "hcm.analytics.individual_development_plan_title": "Plano de desenvolvimento individual",
    "hcm.analytics.internal_vacancies": "Vagas Internas",
    "hcm.analytics.is_not_sucessor": "Não está mapeado como sucessor de alguém",
    "hcm.analytics.jan_mar": "Jan-Mar",
    "hcm.analytics.job_at_place": "{{job}} em {{place}}",
    "hcm.analytics.job_position_desired_summary_label": "Cargo pretendido",
    "hcm.analytics.job_position_desired_summary_title": "Plano de carreira",
    "hcm.analytics.jul_set": "Jul-Set",
    "hcm.analytics.kept_note": "Nota manteve",
    "hcm.analytics.keyPosition": "Posição Chave",
    "hcm.analytics.last_feedback": "Último feedback recebido",
    "hcm.analytics.last_feedbacks_count_15_days": "Recebidos nos últimos 15 dias",
    "hcm.analytics.last_spontaneous_salary_increase_portlet_title": "Últimos aumentos salariais espontâneos",
    "hcm.analytics.update_portlet_information": "Atualizar informações",
    "hcm.analytics.leader": "Líder",
    "hcm.analytics.list_collaborators_from_my_team": "Colaboradores da minha equipe",
    "hcm.analytics.lossImpact": "Impacto da perda",
    "hcm.analytics.lossRisk": "Risco de perda",
    "hcm.analytics.loss_impact": "Impacto de perda",
    "hcm.analytics.loss_risk": "Risco de perda",
    "hcm.analytics.low": "Baixo",
    "hcm.analytics.main_header_title": "Gestão de pessoas",
    "hcm.analytics.many_candidates_to": "Candidatos para",
    "hcm.analytics.many_employee": "Colaboradores",
    "hcm.analytics.map_competences_title": "Aderência ao perfil do cargo / posto",
    "hcm.analytics.map_of_competences": "Mapa de competências do liderado",
    "hcm.analytics.map_of_competences_info": "Os dados apresentados correspondem ao último ciclo concluído da avaliação por competências",
    "hcm.analytics.mapped_successor": "Candidatos mapeados",
    "hcm.analytics.market_wage_level_distance": "Distância para a faixa de mercado",
    "hcm.analytics.medium": "Média",
    "hcm.analytics.members_tab": "Membros",
    "hcm.analytics.men": "Homens",
    "hcm.analytics.message_OUTLET_ID_NAME_EXISTS": "Identificador já cadastrado como favorito.",
    "hcm.analytics.message_permission_updated_error": "A permissão foi atualizada com erro.",
    "hcm.analytics.message_permission_updated_success": "A permissão foi atualizada com sucesso.",
    "hcm.analytics.month_range_generic": "{0} mês(es)",
    "hcm.analytics.months": "mes(es)",
    "hcm.analytics.moods_nps_detractors_value": "Detratores: {0}%",
    "hcm.analytics.moods_nps_not_available": "O NPS ainda não foi avaliado",
    "hcm.analytics.moods_nps_passives_value": "Passivos: {0}%",
    "hcm.analytics.moods_nps_promoters_value": "Promotores: {0}%",
    "hcm.analytics.moods_nps_score_label": "Net Promoter Score por Pulso",
    "hcm.analytics.moods_tab": "Moods",
    "hcm.analytics.moods_tour_title": "Moods",
    "hcm.analytics.multiple_contract_not_being_filtered": "Os dados apresentados não consideram múltiplos contratos.",
    "hcm.analytics.my_academic_profile_tab": "Perfil Acadêmico",
    "hcm.analytics.my_appointment_tour_description": "Nesta guia são apresentadas as informações referentes ao seu ponto de acordo com o mês selecionado.",
    "hcm.analytics.my_appointment_tour_title": "Ponto",
    "hcm.analytics.my_candidatures": "Minhas candidaturas",
    "hcm.analytics.my_career_tour_description": "Aqui você pode consultar as oportunidades de carreira da sua empresa, bem como as vagas em que já se candidatou e os objetivos para o seu plano de carreira, caso você possua.",
    "hcm.analytics.my_career_tour_title": "Carreira",
    "hcm.analytics.my_competencies": "Minhas competências",
    "hcm.analytics.my_competencies_map": "Meu mapa de competências",
    "hcm.analytics.my_department_direct_indirect_led": "Minha área (Liderados diretos e indiretos)",
    "hcm.analytics.my_open_vacancies": "Vagas abertas",
    "hcm.analytics.my_payroll_tour_description": "Também é possível consultar o seu demonstrativo de pagamento do último período de cálculo e o seu saldo de férias.",
    "hcm.analytics.my_payroll_tour_title": "Folha",
    "hcm.analytics.my_pendencies": "Minhas pendências",
    "hcm.analytics.my_performance_tour_description": "As informações referentes às suas avaliações de desempenho de acordo com o ciclo desejado estão presentes nesta guia. Nela também é possível consultar os PDIs e feedbacks recebidos pelo seu gestor e colegas.",
    "hcm.analytics.my_performance_tour_title": "Desempenho",
    "hcm.analytics.my_personal_data_tab": "Dados Pessoais",
    "hcm.analytics.my_personal_interests_tab": "Interesses Pessoais",
    "hcm.analytics.my_professional_profile_tab": "Perfil Profissional",
    "hcm.analytics.my_profile_tab": "Meu Perfil",
    "hcm.analytics.my_profile_tour_description": "Ao clicar no link, você acessa o seu perfil principal. Nele é possível acessar os seus dados pessoais, contatos, endereço, documentos e dados bancários. Seus outros perfis — profissional, acadêmico e público — podem ser acessados pelo menu lateral da plataforma.",
    "hcm.analytics.my_profile_tour_title": "Acessar perfil",
    "hcm.analytics.my_public_profile_tab": "Perfil Público",
    "hcm.analytics.my_score": "Minha pontuação",
    "hcm.analytics.my_score_direct_led": "Minha pontuação (Liderados diretos)",
    "hcm.analytics.my_team_tour_description": "Aqui você visualiza os colegas de trabalho que fazem parte da sua equipe. Também é possível acessar o perfil público dos colegas e escrever ou solicitar um ou mais feedbacks.",
    "hcm.analytics.my_team_tour_title": "Equipe",
    "hcm.analytics.name": "Nome",
    "hcm.analytics.next_pulse": "Próximo pulso",
    "hcm.analytics.next_tour_button": "Próximo",
    "hcm.analytics.next_week": "Próxima semana",
    "hcm.analytics.no": "Não",
    "hcm.analytics.not_found": "Não informado",
    "hcm.analytics.not_measured": "Não avaliado",
    "hcm.analytics.not_served": "Não atendidos",
    "hcm.analytics.not_started": "Não iniciadas",
    "hcm.analytics.IN_SELECTION": "Em seleção",
    "hcm.analytics.note_dropped": "Nota baixou",
    "hcm.analytics.note_increased": "Nota aumentou",
    "hcm.analytics.notice_discontinuation": "Este gráfico de absenteísmo será descontinuado em agosto de 2025 — após essa data, ele não poderá mais ser acessado. Substitua seu uso pelo novo indicador! Para saber como utilizá-lo, acesse a documentação do novo analytics de absenteísmo.",
    "hcm.analytics.only_managers_filtered": "Os dados apresentados consideram apenas o filtro de Gestor.",
    "hcm.analytics.open_vacancies": "Vagas abertas",
    "hcm.analytics.organization_chart_tab": "Organograma",
    "hcm.analytics.organization_score": "Pontuação da organização",
    "hcm.analytics.out_dez": "Out-Dez",
    "hcm.analytics.overtime": "Horas extras",
    "hcm.analytics.overtime_hours_in_calculation_period_title": "Horas extras no período de apuração",
    "hcm.analytics.payroll_my_vacation_balance": "Saldo",
    "hcm.analytics.payroll_my_vacation_doubled": "Dobradas",
    "hcm.analytics.payroll_my_vacation_expired": "Vencidas",
    "hcm.analytics.payroll_my_vacation_proportional": "Proporcionais",
    "hcm.analytics.payroll_not_calculated": "O cálculo da folha de pagamento não foi efetuado até o momento para o mês selecionado, portanto não é possível exibir a quantidade e o valor de horas extras.",
    "hcm.analytics.payroll_tab": "Folha",
    "hcm.analytics.payroll_total_cost_title": "Custo total da folha de pagamento",
    "hcm.analytics.percentage_pattern": "{0}%",
    "hcm.analytics.performance": "Desempenho",
    "hcm.analytics.performance_situation_competence_evaluation_title": "Situação das avaliações por competência",
    "hcm.analytics.performance_situation_performance_evaluation_title": "Situação das avaliações de resultado",
    "hcm.analytics.performance_tab": "Desempenho",
    "hcm.analytics.performance_team_tab_competence_appraisal": "Avaliação por competências",
    "hcm.analytics.performance_team_tab_monitor_goals": "Planos de desenvolvimento",
    "hcm.analytics.performance_team_tab_result_evaluation": "Avaliação de resultado",
    "hcm.analytics.period": "Período",
    "hcm.analytics.personal_information": "Informações pessoais",
    "hcm.analytics.personal_interests": "Interesses pessoais",
    "hcm.analytics.personal_phones": "Telefones Pessoais",
    "hcm.analytics.personnel_request_pendency_summary": "Resumo das pendências de requisição de pessoal",
    "hcm.analytics.phone": "Telefone",
    "hcm.analytics.phones": "Telefones",
    "hcm.analytics.point": "Ponto",
    "hcm.analytics.portlet_key_position_title": "Posição-chave ocupada pelo liderado",
    "hcm.analytics.portlet_monitor_goals": "Situação dos objetivos de desenvolvimento",
    "hcm.analytics.portlet_professional_experience": "Experiência profissional",
    "hcm.analytics.portlet_team_career_plan_title": "Plano de carreira da equipe",
    "hcm.analytics.previous_tour_button": "Voltar",
    "hcm.analytics.previous_week": "Semana anterior",
    "hcm.analytics.process_approval_pendencies": "Requisições pendentes de aprovação",
    "hcm.analytics.professional_profile_resume": "Resumo Profissional",
    "hcm.analytics.professional_profile_resume_placeholder": "Olá! Escreva seu resumo profissional.",
    "hcm.analytics.project_name": "Analytics",
    "hcm.analytics.promotion_time_graph_last_promotion": "desde a última promoção",
    "hcm.analytics.pulse_dashboard_status": "Dados do pulso",
    "hcm.analytics.quadrant": "Quadrante",
    "hcm.analytics.quantity": "Quantidade",
    "hcm.analytics.quantityOfExpiredGoalActions": "Ações de desenvolvimento vencidas",
    "hcm.analytics.quantityOfExpiredGoals": "Objetivos Vencidos",
    "hcm.analytics.quantityOfPendingGoals": "Objetivos em andamento",
    "hcm.analytics.quantityOfWaitingApprovalGoals": "Objetivos aguardando aprovação",
    "hcm.analytics.quantity_of_curriculums": "Quantidade de currículos",
    "hcm.analytics.quantity_of_expired_goal": "Vencido",
    "hcm.analytics.quantity_of_expired_goals": "Vencidos",
    "hcm.analytics.quantity_of_goals_to_expire": "A vencer em 30 dias",
    "hcm.analytics.quantity_of_pending_goal": "Pendente",
    "hcm.analytics.quantity_of_pending_goals": "Pendentes",
    "hcm.analytics.quick_access": "Acesso Rápido",
    "hcm.analytics.range_above": "Acima",
    "hcm.analytics.range_below": "Abaixo",
    "hcm.analytics.range_in": "Dentro",
    "hcm.analytics.ready_successors": "Existe candidato pronto?",
    "hcm.analytics.received": "Recebidos",
    "hcm.analytics.record_found": "registro encontrado",
    "hcm.analytics.records_found": "registros encontrados",
    "hcm.analytics.recruitment": "Gestão de Recrutamento e Seleção",
    "hcm.analytics.recruitment_tab": "Recrutamento e Seleção",
    "hcm.analytics.recruitment_tour_title": "Recrutamento e Seleção",
    "hcm.analytics.remaining_characters": "caracteres restantes",
    "hcm.analytics.remuneration_has_no_successors_detail": "O colaborador não possui sucessores mapeados",
    "hcm.analytics.remuneration_has_no_successors_summary": "Não possui sucessores",
    "hcm.analytics.remuneration_is_not_sucessor_detail": "O colaborador não está mapeado como sucessor de alguém",
    "hcm.analytics.remuneration_is_not_sucessor_summary": "Não é sucessor",
    "hcm.analytics.remuneration_remuneration_vs_performance_without_score": "Não avaliado",
    "hcm.analytics.remuneration_tab": "Remuneração",
    "hcm.analytics.remuneration_tour_title": "Remuneração",
    "hcm.analytics.remuneration_vs_performance": "Remuneração X Desempenho",
    "hcm.analytics.remuneration_vs_performance_tooltip": "São apresentados somente os colaboradores que possuem faixa salarial referência de mercado, avaliações de resultado e competências concluídas dentro de um mesmo ciclo.",
    "hcm.analytics.remuneration_view_export": "Exportar",
    "hcm.analytics.remuneration_export_info_title": "Exportação de arquivo",
    "hcm.analytics.remuneration_salary_increase_export_info_info_message": "As informações dos colaboradores indicados para aumento estão sendo processadas. Você receberá uma notificação com o arquivo exportado quando o processo for concluído.",
    "hcm.analytics.remuneration_salary_framing_export_info_info_message": "As informações do enquadramento salarial dos colaboradores estão sendo processadas. Você receberá uma notificação com o arquivo exportado quando o processo for concluído.",
    "hcm.analytics.replacement": "Substituição",
    "hcm.analytics.request_proposal": "Solicitar proposta",
    "hcm.analytics.result": "Resultado",
    "hcm.analytics.resume_tab": "Resumo",
    "hcm.analytics.resume_tour_description": "Nesta guia estão disponíveis os hyperlinks disponibilizados pela sua empresa e também os cards mais usados que você favoritou.",
    "hcm.analytics.resume_tour_title": "Resumo",
    "hcm.analytics.router_my_analytics": "Meu analytics",
    "hcm.analytics.router_team_analytics": "Analytics da equipe",
    "hcm.analytics.salaryRange": "Faixa Salarial",
    "hcm.analytics.salary_evolution_tip": "O gráfico apresenta a soma dos salários por período. Para visualizar em detalhes é necessário utilizar o filtro por Colaborador",
    "hcm.analytics.salary_framing_details_date_period": "{0} ano(s) e {1} mês(es)",
    "hcm.analytics.salary_framing_details_request_proposal": "Solicitar proposta",
    "hcm.analytics.salary_framing_details_transfer_proposal_tooltip": "Este colaborador está em processo de transferência",
    "hcm.analytics.salary_increase_ranking_title": "Indicados para aumento salarial",
    "hcm.analytics.salary_increase_ranking_title_tooltip": "São apresentados somente os colaboradores que não possuem aumentos salariais (Mérito, Enquadramento ou Promoção) no tempo mínimo definido pelo RH.",
    "hcm.analytics.salary_range_ABOVE": "Acima da faixa salarial",
    "hcm.analytics.salary_range_BELOW": "Abaixo da faixa salarial",
    "hcm.analytics.salary_range_IN": "Dentro da faixa salarial",
    "hcm.analytics.salary_update_in_year": "Aumentos concedidos no ano",
    "hcm.analytics.save": "Salvar",
    "hcm.analytics.score": "Pontuação",
    "hcm.analytics.score_with_param": "Pontuação: {0}",
    "hcm.analytics.search_button_tour_description": "Este botão ajuda você a encontrar todas as pessoas da sua empresa. Nele também é possível buscar pessoas que possuem um interesse pessoal igual ao seu, como por exemplo \"Futebol\".",
    "hcm.analytics.search_button_tour_title": "Buscar pessoas",
    "hcm.analytics.see_all": "Ver todas",
    "hcm.analytics.see_my_profile": "Acessar meu perfil",
    "hcm.analytics.sent_pulses": "Pulsos enviados",
    "hcm.analytics.set_as_key_position": "Classificar como posição-chave",
    "hcm.analytics.show": "Exibir",
    "hcm.analytics.show_all": "Exibir todos",
    "hcm.analytics.show_calendar": "Exibir calendário",
    "hcm.analytics.show_comments": "Exibir comentários",
    "hcm.analytics.since_last_increase": "desde o último aumento",
    "hcm.analytics.single_candidate_to": "Candidato para",
    "hcm.analytics.single_employee": "Colaborador",
    "hcm.analytics.skip_tour_button": "Ver depois",
    "hcm.analytics.social_networks": "Redes Sociais",
    "hcm.analytics.staff_increase": "Aumento de quadro",
    "hcm.analytics.start_my_tour_description": "Olá! Você está na tela de Meu analytics, onde é possível consultar todas as suas informações como colaborador(a). A partir de agora você pode navegar pelas demais telas do sistema a partir de um único lugar. Vamos iniciar um tour para conhecer os principais recursos?",
    "hcm.analytics.start_team_tour_description": "Olá! Você está na tela de Analytics da equipe, onde é possível consultar as informações dos seus liderados para uma tomada de decisão mais ágil. A partir de agora você pode navegar pelas demais telas do sistema a partir de um único lugar. Vamos iniciar um tour para conhecer os principais recursos?",
    "hcm.analytics.start_tour": "Iniciar tour",
    "hcm.analytics.start_tour_button": "Iniciar",
    "hcm.analytics.start_tour_description": "Fazer o tour pelo Analytics",
    "hcm.analytics.startdate_to_enddate": "{{startdate}} até {{enddate}}",
    "hcm.analytics.startdate_to_enddate2": "{{startdate}} a {{enddate}}",
    "hcm.analytics.started_at_date": "Iniciou em {{startDate}}",
    "hcm.analytics.succession": "Sucessão",
    "hcm.analytics.succession_plan": "Plano de sucessão",
    "hcm.analytics.successorOf": "Sucessor de",
    "hcm.analytics.successors": "Sucessores",
    "hcm.analytics.team_appointment_tour_description": "Nesta guia você pode gerenciar a jornada de trabalho da sua equipe de forma simples e precisa, através dos dados de marcação de ponto.",
    "hcm.analytics.team_appointment_tour_title": "Ponto",
    "hcm.analytics.team_career_tour_description": "Nesta guia é possível consultar as informações de carreira dos liderados, bem como acessar as telas para realizar o mapeamento de carreira da equipe e identificar os candidatos à sucessão.",
    "hcm.analytics.team_career_tour_title": "Carreira",
    "hcm.analytics.team_features_tour_description": "Aqui estão disponíveis os indicadores demográficos da sua equipe. Os gráficos são interativos, clique sobre eles para ver mais detalhes sobre os dados.",
    "hcm.analytics.team_features_tour_title": "Perfil da equipe",
    "hcm.analytics.team_moods_tour_description": "Por último, você pode consultar os indicadores de clima da sua equipe em tempo real. Assim é possível tomar ações rápidas, caso o clima da sua equipe esteja com uma pontuação baixa.",
    "hcm.analytics.team_payroll_tour_description": "Consulte os custos da folha de pagamento e horas extras através desta guia. Nela você pode acompanhar os vencimentos de contratos, controlar e programar as férias da equipe.",
    "hcm.analytics.team_payroll_tour_title": "Folha",
    "hcm.analytics.team_performance_tour_description": "É aqui onde você consulta as informações de desempenho, visualiza os feedbacks e também define e controla o plano de desenvolvimento da sua equipe.",
    "hcm.analytics.team_performance_tour_title": "Desempenho",
    "hcm.analytics.team_profile": "Perfil da equipe",
    "hcm.analytics.team_recruitment_tour_description": "Você também pode acompanhar como está o andamento das suas requisições de pessoal, das vagas em aberto na sua equipe e também dos indicadores de Gestão de Recrutamento e Seleção e seleção.",
    "hcm.analytics.team_remuneration_tour_description": "Pode também gerenciar a remuneração da equipe, fazendo o acompanhamento das propostas salariais com assertividade através desta guia.",
    "hcm.analytics.team_tab": "Equipe",
    "hcm.analytics.team_team_tour_description": "Visualize a sua equipe. Aqui também é possível acessar o Analytics e o perfil público dos liderados e escrever ou solicitar um ou mais feedbacks.",
    "hcm.analytics.team_team_tour_title": "Equipe",
    "hcm.analytics.telephone": "Telefone",
    "hcm.analytics.telephones": "Telefones",
    "hcm.analytics.there_are_no_successors": "Não possui sucessores mapeados",
    "hcm.analytics.this_month": "Este mês",
    "hcm.analytics.this_week": "Esta semana",
    "hcm.analytics.time_last_increase": "Tempo do último aumento",
    "hcm.analytics.title_card_direct_descendants": "Liderados diretos ",
    "hcm.analytics.title_card_pulses": "Pontuação por dimensão",
    "hcm.analytics.to_detail": "Detalhar",
    "hcm.analytics.today": "Hoje",
    "hcm.analytics.tooltip_dashboard_hourly_monthly": "O valor do salário dos colaboradores mensalistas e horistas são apresentados de acordo com as configurações definidas pelo RH.",
    "hcm.analytics.total": "Total",
    "hcm.analytics.training_time": "Horas de treinamento",
    "hcm.analytics.trimesters": "Trimestres",
    "hcm.analytics.ultimos_30_dias": "últimos 30 dias",
    "hcm.analytics.unavailable_info_on_phone_title": "Essas informações não são compatíveis com o tamanho da tela.",
    "hcm.analytics.undefined": "Não definidos",
    "hcm.analytics.vacancies": "Vagas",
    "hcm.analytics.vacancies_balance": "Saldo",
    "hcm.analytics.vacancies_canceled": "Canceladas",
    "hcm.analytics.vacancies_closed": "Concluídas",
    "hcm.analytics.vacancies_opened": "Abertas",
    "hcm.analytics.vacancy": "Vaga",
    "hcm.analytics.valid_until": "válido até {{date}}",
    "hcm.analytics.ver_detalhes": "Ver detalhes",
    "hcm.analytics.waiting_approval": "Aguardando aprovação",
    "hcm.analytics.with_attendance_of_attendance": "com frequência de {{attendance}}",
    "hcm.analytics.with_conclusion_on_endDate": "com término em {{endDate}}",
    "hcm.analytics.with_expected_conclusion_on_endDate": "com término previsto em {{endDate}}",
    "hcm.analytics.women": "Mulheres",
    "hcm.analytics.years": "ano(s)",
    "hcm.analytics.yes": "Sim",
    "hcm.analytics.error": "Erro",
    "platform.filter_service.hcm_analytics_filter_contract_types_aprendiz": "Aprendiz",
    "platform.filter_service.hcm_analytics_filter_contract_types_cooperative_worker": "Cooperado",
    "platform.filter_service.hcm_analytics_filter_contract_types_domestic_worker": "Trabalhador Doméstico",
    "platform.filter_service.hcm_analytics_filter_contract_types_employee": "Empregado",
    "platform.filter_service.hcm_analytics_filter_contract_types_farm_worker": "Trabalhador Rural",
    "platform.filter_service.hcm_analytics_filter_contract_types_fixed_due_date": "Prazo Determinado",
    "platform.filter_service.hcm_analytics_filter_contract_types_manager": "Diretor",
    "platform.filter_service.hcm_analytics_filter_contract_types_public_agent": "Agente Público",
    "platform.filter_service.hcm_analytics_filter_contract_types_retired": "Aposentado",
    "platform.filter_service.hcm_analytics_filter_contract_types_retired_manager": "Diretor Aposentado",
    "platform.filter_service.hcm_analytics_filter_contract_types_teacher": "Professor",
    "platform.filter_service.hcm_analytics_filter_contract_types_teacher_fixed_due_date": "Professor, Prazo Determinado",
    "platform.filter_service.hcm_analytics_filter_contract_types_trainee": "Estagiário",
    "platform.filter_service.hcm_analytics_shift_first_turn": "Primeiro turno",
    "platform.filter_service.hcm_analytics_shift_fourth_turn": "Quarto turno",
    "platform.filter_service.hcm_analytics_shift_general": "Turno geral",
    "platform.filter_service.hcm_analytics_shift_mist": "Turno misto",
    "platform.filter_service.hcm_analytics_shift_second_turn": "Segundo turno",
    "platform.filter_service.hcm_analytics_shift_third_turn": "Terceiro turno",
    "hcm.analytics.sst_tab": "Saúde e Segurança",
    "hcm.analytics.dashboard_sst_work_accident": "Totalizadores de acidentes",
    "hcm.analytics.dashboard_sst_personal_protective_equipment": "Totalizadores de EPIS",
    "hcm.analytics.MODULE_TYPE_SST": "Saúde e Segurança",
    "hcm.analytics.dashboard_sst_employee_course": "Totalizadores de treinamentos obrigatórios SST",
    "hcm.analytics_sst.employee_examination_analytics_totalizer_title": "Totalizadores de ASO Periódico",
    "hcm.analytics_payroll.employee_absenteeism_analytics_totalizer_title": "Totalizadores de absenteísmo",
    "hcm.analytics.moods_data_not_being_filtered": "Os dados apresentados não consideram o filtro aplicado nesta tela, o pulso selecionado é o que foi filtrado na tela de Analytics da pesquisa Gestor.",
    "hcm.analytics.moods_score_pulse": "Para compor a pontuação do pulso, também são consideradas as dimensões enviadas nos pulsos anteriores. Ou seja, se a dimensão estiver ativa, mas não foi enviada no pulso atual, o seu resultado ainda é contabilizado na pontuação apresentada. Os dados apresentados consideram apenas o filtro de Gestor.",
    "hcm.analytics.moods_title_info_analytics_manager": "Analytics da pesquisa - Gestor",
    "hcm.analytics.moods_description_info_analytics_manager": "para ver todos os dados e gráficos detalhados no Analytics da pesquisa.",
    "hcm.analytics.moods_click_info_analytics_manager": "Clique aqui",
    "hcm.moods.analytics_waiting_description": "O gráfico está sendo processado, isto pode levar alguns segundos.",
    "hcm.moods.analytics_error_description": "Houve um erro ao processar o gráfico, entre em contato com o administrador do sistema.",
    "hcm.analytics.CONTRIBUINTE_INDIVIDUAL_DIRETOR_NAO_EMPREGADO_SEM_FGTS": "Contribuinte Individual - Diretor não empregado sem FGTS"
};
